import { createSlice } from "@reduxjs/toolkit";
import { whoamiApi } from "Services";
import { sessionExpiredAction } from "Utils";
import { RootState } from "./rootReducer";

type AuthState = {
  isAuthenticated: boolean;
  isInitialized: boolean;
};

const initialState: AuthState = {
  isAuthenticated: false,
  isInitialized: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sessionExpiredAction, (state) => {
      state.isAuthenticated = false;
      state.isInitialized = true;
    });
    builder.addMatcher(
      whoamiApi.endpoints.getWhoami.matchFulfilled,
      (state) => {
        state.isAuthenticated = true;
        state.isInitialized = true;
      },
    );
    builder.addMatcher(whoamiApi.endpoints.getWhoami.matchRejected, (state) => {
      state.isAuthenticated = false;
      state.isInitialized = true;
    });
  },
});

export const selectAuth = (state: RootState): AuthState => state.auth;

export default authSlice.reducer;
